export default {
  header: 'Szybka nawigacja {assetDisplayName}',
};
